<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
            	<div class="col-12 mt-4 mb-4 redeem-ggc-products">
                    
	            	
                    <div class="card">
                        <div class="card-body">
                            <form id="frm_company_email" action="" enctype="multipart/form-data" method="POST" @submit="formSubmit">
                                <table width="100%" class="table">
                                    <tbody>
                                        <input type="hidden" name="_token" v-bind:value="csrf">
                                        <tr>
                                            <td style="border-top: 0;">
                                                <img class="product_image" v-bind:src="product_image" v-bind:alt="ggc_product.name"  v-bind:title="ggc_product.name" width="auto" height="196" />
                                                <h1 style="margin-bottom: 0;" class="text-center">{{ ggc_product.name }} Redemption</h1>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border-top: 0;">
                                                <div class="label">Order Number</div>
                                                <h3 style="margin-bottom: 0;">{{ order_number }}</h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border-top: 0;">
                                                <div class="label">Status</div>
                                                <h3 style="margin-bottom: 0;" v-if="redeemable == 1">Valid</h3>
                                                <h3 style="margin-bottom: 0;" v-if="redeemable == 0">Redeemed</h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border-top: 0;">
                                                <div class="label">Amount</div>
                                                <h3 style="margin-bottom: 0;">{{ order_subtotal | | currency('₱') }}</h3>
                                            </td>
                                        </tr>
                                        <tr v-if="redeemable == 1 && allow_change_email == 1">
                                            <td style="border-top: 0;">
                                                <div class="label">Recipient Email</div>
                                                <input class="form-control" type="email" name="email" id="email" value="" placeholder="Your Email" required="" v-bind:value="email" />
                                            </td>
                                        </tr>
                                        <tr v-if="redeemable == 1 && email != ''">
                                            <td style="border-top: 0;">
                                                <div class="label">Recipient Email</div>
                                                <h3 style="margin-bottom: 0;">{{ email }}</h3>
                                            </td>
                                        </tr>
                                        <tr v-if="redeemable == 1" style="text-align: center;">
                                            <td style="border-top: 0;">
                                                <div style="width: 100%;overflow: hidden;margin: 0 auto 5px;max-width: 303px;position: relative;clear: both;">
                                                    <vue-recaptcha sitekey="6Lf75zEUAAAAAI3SawkXu1GCgLeDaZbfvudKzDMX" :loadRecaptchaScript="true"></vue-recaptcha>
                                                </div>
                                                <button class="btn btn-redeem">Claim Credits</button>
                                            </td>
                                        </tr>
                                        <tr v-if="redeemable == 0" style="text-align: center;">
                                            <td style="border-top: 0;">
                                                <a class="btn btn-redeem" v-bind:href="product_slug">Select Products</a>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </form>

                        </div>


                    </div>
                    <p class="text-center mt-2">Having an issue? Please email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
				</div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .redeem-ggc-products{
        max-width: 420px;
        margin: 0 auto;
        width: 100%;
        text-align: center;
    }
    .redeem-ggc-products .product_image{
        border: 1px solid #ccc;
        border-radius: 5px;
        overflow: hidden;
        margin: 0 auto 15px;
    }
    .redeem-ggc-products h1{
        font-size: 25px;
        margin: 0 auto 15px;
    }
    .redeem-ggc-products h3{
        font-size: 20px;
        line-height: 20px;
        margin: 0 auto;
        text-align: center;
    }
    .redeem-ggc-products .label{
        color: #000;
        font-size: 12px;
        text-align: center;
        width: auto;
        padding: 0 6px;
        margin: 0 auto 5px;
        display: block;
        max-width: 100px;
    }
    .redeem-ggc-products .btn-redeem{
        background-color: #de3c4c;
        color: #fff;
        width: 100%;
        max-width: 300px;
        margin: 5px auto 0;
        padding: 10px;
        font-size: 20px;
    }
    .redeem-ggc-products .btn-redeem:hover{
        background-color: #ad2936;
    }

</style>

<script>
	import moment from 'moment'
    import VueRecaptcha from 'vue-recaptcha'

	export default {
        components: { VueRecaptcha },
        props: ['product', 'ggc', 'order'],
        data: () => ({
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            ggc_product: "",
            email: "",
            not_valid: "",
            redeemable: "",
            recaptcha_is_valid: "",
            wallet_exist: "",
            product_image: "",
            order_id: "",
            order_number: "",
            order_status: "",
            order_subtotal: "",
            order_recipient_email: "",
            allow_change_email: "",
            product_slug: "",
        }), 
        mounted() {

            const product = JSON.parse(this.product);
            this.ggc_product = product;
            this.product_slug = '/redeem/ggc-products/'+product.slug;
            console.log(product);

            const ggc = JSON.parse(this.ggc)
            this.email = ggc.email;
            this.not_valid = ggc.not_valid;
            this.redeemable = ggc.redeemable;
            this.recaptcha_is_valid = ggc.recaptcha_is_valid;
            this.wallet_exist = ggc.wallet_exist;
            this.product_image = ggc.image;
            this.allow_change_email = ggc.allow_change_email;

            const order = JSON.parse(this.order)
            this.order_id = order.id;
            this.order_number = order.order_number;
            this.order_status = order.status;
            this.order_subtotal = order.subtotal;
            this.recipient_email = order.recipient_email;


        },
        methods: {
            formSubmit: function (e) {
                e.preventDefault();

                var recaptcha = $('#g-recaptcha-response').val();
                var new_email = $('#email').val();
                new_email = new_email ? new_email : this.recipient_email;

                if(recaptcha){

                    Swal.fire({
                      icon: 'warning',
                      title: 'Please wait!',
                      html: 'Your credits are processing...',
                      showConfirmButton: false,
                    });


                    $.ajax({
                        type: "POST",
                        url: "/api/ggc_product/claim",
                        data: { 'csrf': this.csrf, 'order_id': this.order_id, 'email': new_email },
                        cache: false,
                    })
                    .then(response => {
                        console.log(response);

                        const result = JSON.parse(response);

                        if(result.response.class == "success"){    
                            
                            Swal.fire({
                                icon: result.response.class,
                                title: result.response.message,
                                confirmButtonColor: '#DE3C4C',
                                showLoaderOnConfirm: true,
                                background: '#fff',
                                backdrop: 'rgb(198, 227, 222)',
                                html: '',
                              confirmButtonColor: '#DE3C4C',
                              confirmButtonText: 'Close'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    location.reload();
                                }
                            });
                            
                        }else{
                            
                            Swal.fire({
                                icon: result.response.class,
                                title: result.response.message,
                                showConfirmButton: false,
                            });
                            
                        }
                       
                    })
                    .catch(error => {
                        Swal.showValidationMessage(
                          `Request failed! Please contact support admin@gifted.ph.`
                        )
                    });
                }else{
                    Swal.fire({
                      icon: 'warning',
                      showConfirmButton: true,
                    });

                    Swal.showValidationMessage(
                      `recCAPTCHA is required.`
                    );
                }
            }
        },
        filters: {
          moment: function (date) {
            return moment(date).format('MMMM D, YYYY h:mm:ss A');
          }
        }
    }


</script>